import { useMemo } from 'react';
import { useUser } from '../../../redux/user/useUser';

import { TabNavigationLayout } from '../../templates/TabNavigationLayout';
import { PageWrapper } from '../../atoms/PageWrapper';
import { ProgramWhileStudyings } from './ProgramWhileStudyingList';
import { CourseProgramWhileStudyings } from './CourseProgramWhileStudyingList';
import { FunctionType, PermissionType } from '../../../const/UserPermission';
import { useLocation } from 'react-router-dom';
import { LOWER_META_TITLE, SERVICE_NAME } from '../../../const/Service';
import { PROGRAM_COUNT } from '../../../const/Program';

export const ProgramWhileStudying = (): JSX.Element => {
  const metaTitle = `学習中の教材 | ${LOWER_META_TITLE}`;
  const metaDescription = `${SERVICE_NAME}のプログラミング学習教材ページです。ITリテラシーからフロントエンド、バックエンド、インフラまで全${PROGRAM_COUNT}種類以上の教材をご用意。入門者や初心者にも優しい基礎教材はもちろん実務レベルのエンジニアになるための中級者向け教材も。`;

  const { permissionCheck } = useUser();
  const location = useLocation();

  const limit = 100;
  const offset = 1;

  const tabs = useMemo(() => {
    const tabs = [];
    permissionCheck(FunctionType.ProgramForInstructorAndCoach, PermissionType.Read)
      ? tabs.push(
          { label: '学習用教材', to: '/programs?type=1', active: location.search === '?type=1' },
          {
            label: 'インストラクター向けマニュアル',
            to: '/programs?type=2',
            active: location.search === '?type=2',
          },
        )
      : tabs.push(
          { label: '教材TOP', to: '/programs', active: location.pathname === '/programs' },
          {
            label: '学習中の教材',
            to: '/programs_while_studying',
            active: location.pathname === '/programs_while_studying',
          },
          {
            label: '完了した教材',
            to: '/programs_completed_study',
            active: location.pathname === '/programs_completed_study',
          },
        );

    return tabs;
  }, [location.pathname, location.search, permissionCheck]);

  return (
    <TabNavigationLayout pageTitle="教材" tabs={tabs} metaTitle={metaTitle} metaDescription={metaDescription}>
      <PageWrapper>
        {permissionCheck(FunctionType.StudyLog, PermissionType.Read) && (
          <>
            <CourseProgramWhileStudyings showWhileStudyingLink={false} showNoContentsMessage={true} />
            <ProgramWhileStudyings
              limit={limit}
              offset={offset}
              showWhileStudyingLink={false}
              showNoContentsMessage={true}
            />
          </>
        )}
      </PageWrapper>
    </TabNavigationLayout>
  );
};
